// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__3U-0D","left":"Virtual_left__1lxhQ","wrapper":"Virtual_wrapper__CrKN4"};